<template>
  <div class="container">
    <div class="blog-post">
      <router-link
        :to="{
          name: 'blog details',
          params: { blogId: blogs[0].id },
        }"
        class="feature-wrap"
      >
        <div class="featured-post">
          <img :src="blogs[0].image[0].url" />
          <div class="blog-post-info">
            <p class="post-published-at greyText">
              {{ getTime(blogs[0].publishedtime) }}
            </p>
            <h3 class="post-title">
              {{ blogs[0].title }}
            </h3>
            <p v-html="blogs[0].content.slice(0, 300) + `.....`"></p>
            <p class="post-read-time greyText">
              {{ WordTimeCount(blogs[0].content) }} minutes read
            </p>
          </div>
        </div>
      </router-link>
    </div>
    <h3 class="heading2">Latest Blogs</h3>
    <div class="grid-blogs">
      <div
        class="blog-post blogCards"
        v-for="b in blogs.slice(1, 5)"
        :key="b.id"
      >
        <router-link
          :to="{
            name: 'blog details',
            params: { blogId: b.id },
          }"
        >
          <img :src="b.image[0].url" class="cardPic" />
          <div class="blog-post-info">
            <!-- applying a quick fix to special char problem -->
            <p class="post-published-at greyText">
              {{ getTime(b.publishedtime) }}
            </p>
            <h3 class="post-title cardTitle">{{ b.title }}</h3>
            <p class="post-read-time greyText">
              {{ WordTimeCount(b.content) }} mins read
            </p>
          </div>
        </router-link>
      </div>
    </div>
    <h3 class="heading2">Read More</h3>
    <div class="blog-post" v-for="b in blogs.slice(5)" :key="b.id">
      <router-link
        :to="{
          name: 'blog details',
          params: { blogId: b.id },
        }"
        class="bottomBlogs"
      >
        <img :src="b.image[0].url" class="cardPic" />
        <div class="blog-post-info">
          <p class="post-published-at greyText">
            {{ getTime(b.publishedtime) }}
          </p>
          <h3 class="post-title cardTitle">
            {{ b.title }}
          </h3>
          <p class="post-read-time greyText">
            {{ WordTimeCount(b.content) }} mins read
          </p>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
var moment = require('moment')
export default {
  data() {
    return {
      blogs: [],
    }
  },
  created() {
    this.$upskill.blogs().then((res) => {
      let blogData = res.data.filter(o => o.tag == null)
      blogData.sort((a, b) => {
        let x = new Date(a.publishedtime)
        let y = new Date(b.publishedtime)
        return y - x
      })
      this.blogs = blogData
      this.Loaded()
    })
  },
  methods: {
    getTimeLeft(bgtime) {
      return moment(bgtime).fromNow()
    },
    getTime(wstime) {
      return moment(wstime).format('ddd, DD MMMM, YYYY')
    },
  },
  async mounted() {
    const promisesBlog = this.GET_BLOGDATA()
    await Promise.all([promisesBlog])
    this.Loaded()
  },
}
</script>
<style scoped>
* {
  color: black;
}
.greyText {
  color: grey;
}
.post-title {
  font-weight: 600;
  color: rgba(0, 0, 0, 0.76);
}
.heading2 {
  border-bottom: 2px solid black;
}
.feature-wrap .featured-post {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1em;
  padding: 1em;
  max-width: 1310px;
  margin-bottom: 3em;
}
.featured-post img {
  width: 95%;
  border-radius: 6px;
  box-shadow: 0 0px 10px #ccc;
}
.blog-post-info {
  margin-top: 1.5em;
  padding-right: 5em;
}
.grid-blogs {
  margin-bottom: 1.5em;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  row-gap: 1.5em;
  max-width: 1310px;
}
.blogCards {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 90%;
  align-items: baseline;
  height: 400px;
  padding: 1em;
  max-width: 90%;
  overflow: hidden;
}
.bottomBlogs {
  display: grid;
  grid-template-columns: 1fr 2fr 1fr;
  gap: 1.5em;
  padding: 1em;
  max-width: 1310px;
}
.cardTitle {
  font-size: 18px;
}
.cardPic {
  object-fit: cover;
  width: 100%;
  height: 200px;
}
@media screen and (max-width: 800px) {
  .feature-wrap .featured-post {
    grid-template-columns: 1fr;
  }
  .grid-blogs {
    grid-template-columns: 1fr;
    margin-bottom: 1em;
  }
  .bottomBlogs {
    grid-template-columns: 1fr 1fr;
    gap: 1em;
    padding-left: 0;
    row-gap: 1em;
  }
  .blogCards img {
    max-width: 300px;
  }
  .bottomBlogs img {
    object-fit: cover;
    width: 100%;
    height: auto;
  }
  .blogCards {
    padding: 0;
    height: auto;
  }
  .bottomBlogs .blog-post-info {
    padding: 0;
    margin: 0;
  }
  .featured-post .blog-post-info {
    padding: 0;
    margin: 0;
  }
}
</style>
